import { useTheme } from "next-themes";

type LogoProps = { className?: string };

function BrandLogo({ src, alt, className = "h-4 w-4" }: { src: string; alt: string } & LogoProps) {
  return <img src={src} alt={alt} className={`inline-block shrink-0 object-contain ${className}`} />;
}

// The product's own mark — light/dark aware, unlike the third-party brand
// logos below (those are flat SVGs that already read fine on either
// background). AppetisedIcon is the {a} mark alone (header logo column,
// MCP hub — see BrandMarks... er, the design handoff README's "identity
// only" rule); AppetisedLogo is the full "{a} appetised" wordmark (page
// headers, the Clerk auth modal). Both source PNGs are non-square (a wide
// canvas around the mark), so object-contain — not the surrounding box's
// aspect ratio — is what keeps them undistorted.
export function AppetisedIcon({ className }: LogoProps) {
  const { resolvedTheme } = useTheme();
  const src = resolvedTheme === "dark" ? "/appetised-icon-dark.png" : "/appetised-icon-light.png";
  return <BrandLogo src={src} alt="appetised" className={className} />;
}

export function AppetisedLogo({ className }: LogoProps) {
  const { resolvedTheme } = useTheme();
  const src = resolvedTheme === "dark" ? "/appetised-logo-dark.png" : "/appetised-logo-light.png";
  return <BrandLogo src={src} alt="appetised" className={className} />;
}

export function GmailLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-gmail.svg" alt="Gmail" className={className} />;
}

export function SlackLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-slack.svg" alt="Slack" className={className} />;
}

export function TeamsLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-teams.svg" alt="Microsoft Teams" className={className} />;
}

export function WhatsAppLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-whatsapp.svg" alt="WhatsApp" className={className} />;
}

export function OutlookLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-outlook.svg" alt="Outlook" className={className} />;
}

export function JiraLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-jira.svg" alt="Jira" className={className} />;
}

export function AzureDevOpsLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-azure-devops.svg" alt="Azure DevOps" className={className} />;
}

export function GoogleCalendarLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-google-calendar.svg" alt="Google Calendar" className={className} />;
}

export function OutlookCalendarLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-outlook-calendar.svg" alt="Outlook Calendar" className={className} />;
}

export function ClaudeLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-claude.svg" alt="Claude" className={className} />;
}

export function ChatGPTLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-chatgpt.svg" alt="ChatGPT" className={className} />;
}

export function GoogleGeminiLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-google-gemini.svg" alt="Google Gemini" className={className} />;
}

export function GithubCopilotLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-github-copilot.svg" alt="GitHub Copilot" className={className} />;
}

export function MicrosoftCopilotLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-microsoft-copilot.svg" alt="Microsoft Copilot" className={className} />;
}

export function PerplexityLogo({ className }: LogoProps) {
  return <BrandLogo src="/brand-perplexity.svg" alt="Perplexity" className={className} />;
}
